import AnnotatorView from './AnnotatorView';
// import AnnotatorView from './annotator1';

export default AnnotatorView;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/container/AnnotatorView/index.js